import { useCallback, useEffect, useRef, useState } from "react";
import AutocompleteFetchInput from "../../../javascript/presentation/components/inputs/autocomplete-fetch-input";
import { getWorkAssignees } from "../../../javascript/api/works";
import { toAssigneeOptions } from "../../../javascript/helpers/helpers";

const WorkAssigneeFilter = ({ onChange, accountId, clearFilter, selectedIds = [] }) => {
    const [selectedWorkOptions, setSelectedWorkOptions] = useState(selectedIds.map((id) => ({ value: id, label: 'Carregando...' })));
    const initializedIds = useRef([]);

    const handleWorksChange = (data) => {
        const newIds = data.map((work) => work.value);

        initializedIds.current = newIds;

        setSelectedWorkOptions(data);
        onChange(newIds);
    };

    useEffect(() => {
        if (clearFilter) {
            setSelectedWorkOptions([]);
            initializedIds.current = [];
        }
    }, [clearFilter]);

    const fetchWorksAssignees = useCallback(async (q = "") => {
        try {
            const result = await getWorkAssignees({ accountId, q });
            return toAssigneeOptions(result.results);
        } catch (err) {
            console.error(err);
            return [];
        }
    }, [accountId]);

    useEffect(() => {
        if (
            !selectedIds.length || JSON.stringify(initializedIds.current) === JSON.stringify(selectedIds)
        ) {
            return;
        }

        initializedIds.current = [...selectedIds];

        getWorkAssignees({ accountId, userIds: selectedIds })
            .then((result) => setSelectedWorkOptions(toAssigneeOptions(result.results)))
            .catch(console.error);
    }, [accountId, selectedIds]);

    return (
        <AutocompleteFetchInput
            label="Responsáveis"
            value={selectedWorkOptions}
            setValue={handleWorksChange}
            fetchOptions={fetchWorksAssignees}
        />
    );
}

export default WorkAssigneeFilter;